import { Grid } from 'theme-ui';
import AppFeatureHeader from './Header';
import ImgLoader from '~/components/Generic/ImgLoader';
import AppFeatureFooter from './Footer';

const AppFeature = ({ section }) => {
  const { images, title, subtitle, description, ctaButton, extraColumnBody } = section;

  const appLogo = images[0];
  const appImage = images[1];

  return (
    <Grid
      sx={{
        gridTemplateColumns: ['1fr', '1fr 2fr'],
        gap: '2.4rem',
        justifyItems: ['center', 'start'],
        alignItems: 'start',
      }}
    >
      <AppFeatureHeader
        appLogo={appLogo}
        ctaButton={ctaButton}
        subtitle={subtitle}
        title={title}
        description={description}
      />
      <ImgLoader
        image={appImage}
        forwardSx={{ my: [0, '4.8rem'], gridRow: ['auto', '1/3'], gridColumn: ['auto', '2/3'] }}
      />
      <AppFeatureFooter appLogo={appLogo} ctaButton={ctaButton} extraColumnBody={extraColumnBody} />
    </Grid>
  );
};

export default AppFeature;
